import { L2Page } from 'common/tracking/navigation';

export const TEAM_MEMBER_TAB = L2Page.TEAM;

export const SHIFTS_TAB = L2Page.ROTA;

export const VALID_TABS = [TEAM_MEMBER_TAB, SHIFTS_TAB];

export const LIVE_CHAT_SOURCE = 'team sidebar';
